document.addEventListener("DOMContentLoaded", function() {
  const listItems = document.querySelectorAll("li");

  listItems.forEach(item => {
      item.innerHTML = item.innerHTML.replace(/\bvar\b/g, '<span class="var">var</span>');
  });
});